import styled from 'styled-components';

const StyledGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-auto-rows: 185px;
	gap: 10px;
	width: 100%;
	overflow: scroll;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export { StyledGrid };
